import React from 'react';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 w-full h-8 bg-surface-container-lowest border-t border-outline-variant/20 flex justify-between items-center px-4 md:px-6 z-50 transition-colors duration-300">
      <div className="flex space-x-6">
        <span className="font-['Space_Grotesk'] text-[10px] text-on-surface-variant font-mono">
          © {new Date().getFullYear()} Nomit Verma
        </span>
      </div>
      <div className="hidden md:flex space-x-6 font-['Space_Grotesk'] text-[10px] font-mono">
        <span className="text-on-surface-variant/60 hover:text-on-surface cursor-default transition-colors">CPU: 12%</span>
        <span className="text-on-surface-variant/60 hover:text-on-surface cursor-default transition-colors">Uptime: 99.9%</span>
        <span className="text-on-surface-variant flex items-center">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1.5 inline-block"></span>
          STABLE
        </span>
      </div>
    </footer>
  );
};

export default Footer;
